import React from 'react';
import { Main } from './components';

const InvoicesView = () => <Main />;

export default InvoicesView;
